<template>
  <v-form @submit.prevent="$v.$invalid ? () => {} : submit()" ref="form">
    <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
      <span>{{$t(page+'.'+message)}}</span>
    </v-snackbar>
    <v-card class="neu-glow elevation-8 pb-3 mb-3 ml-3">
      <v-card-title primary-title class="pb-0">
        <div class="text-h5">Loghi</div>
        <v-spacer></v-spacer>
        <v-div>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading"  @click.stop="getData()">
                <v-icon color="info">mdi-sync-circle</v-icon>
              </v-btn>
            </template>
            <span>Refresh</span>
          </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction=true">
                  <v-icon color="info">mdi-help-circle</v-icon>
                </v-btn>
              </template>
              <span>Istruzioni</span>
            </v-tooltip>           
        </v-div>
      </v-card-title>
      <v-container grid-list-xl fluid>
        <v-row class="my-2">
          <v-col md="6" cols="12">
              <div class="ml-2">
                Favicon (16 x 16px)                 
              </div>
          </v-col>
          <v-col md="6" cols="12" class="py-0">
            <div class="d-flex flex-column justify-space-between align-center">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <div class="elevation-10" v-bind="attrs" v-on="on" id="pick-avatar0" style="cursor:pointer">
                    <v-img
                      :lazy-src="logo_0"
                      max-height="16"
                      max-width="16"
                      :src="logo_0"
                    ></v-img>
                  </div>                  
                </template>
                <span>Cambia</span>
              </v-tooltip>                
            </div>
            <avatar-cropper
              :uploadFormData="{name:'logo_0',type:'logo'}"
              :outputOptions="outputOptions0"
              :cropperOptions="cropperOptions0"
              @uploading="handleUploading"
              @uploaded="handleUploaded"
              @completed="handleCompleted"
              @error="handlerError"
              trigger="#pick-avatar0"
              upload-url="https://booking.jslab.it/ajax/settings/upload.php" 
            />
          </v-col>
        </v-row>
        <v-row class="my-2">
          <v-col md="6" cols="12">
            <div class="ml-2">
              Logo Azienda (200 x 35px)                
            </div>
          </v-col>
          <v-col md="6" cols="12" class="py-0">
            <div class="d-flex flex-column justify-space-between align-center">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <div class="elevation-10" v-bind="attrs" v-on="on" id="pick-avatar1" style="cursor:pointer">
                    <v-img
                      :lazy-src="logo_1"
                      max-height="46"
                      max-width="200"
                      :src="logo_1"
                    ></v-img>
                  </div>                  
                </template>
                <span>Cambia</span>
              </v-tooltip>                 
            </div>
            <avatar-cropper
              :uploadFormData="{name:'logo_1',type:'logo'}"
              :outputOptions="outputOptions1"
              :cropperOptions="cropperOptions1"
              @uploading="handleUploading"
              @uploaded="handleUploaded"
              @completed="handleCompleted"
              @error="handlerError"
              trigger="#pick-avatar1"
              upload-url="https://ibookrestaurant.com/ajax/settings/upload.php" 
            />
          </v-col>
        </v-row>
        <v-row class="my-2">
          <v-col md="6" cols="12">
            <div class="ml-2">
              Logo Azienda (400 x 200px)
            </div>
          </v-col>
          <v-col md="6" cols="12" class="py-0">
            <div class="d-flex flex-column justify-space-between align-center">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <div class="elevation-10" v-bind="attrs" v-on="on" id="pick-avatar2" style="cursor:pointer">
                    <v-img
                      :lazy-src="logo_2"
                      max-height="100"
                      max-width="200"
                      :src="logo_2"
                    ></v-img>
                  </div>                  
                </template>
                <span>Cambia</span>
              </v-tooltip>               
            </div>
            <avatar-cropper
              :uploadFormData="{name:'logo_2',type:'logo'}"
              :outputOptions="outputOptions2"
              :cropperOptions="cropperOptions2"
              @uploading="handleUploading"
              @uploaded="handleUploaded"
              @completed="handleCompleted"
              @error="handlerError"
              trigger="#pick-avatar2"
              upload-url="https://booking.jslab.it/ajax/settings/upload.php" 
            />
          </v-col>
        </v-row>
        <v-row class="my-2">
          <v-col md="6" cols="12">
            <div class="ml-2">
              Logo Azienda (1000 x 1000px)                  
            </div>
          </v-col>
          <v-col md="6" cols="12" class="py-0">
            <div class="d-flex flex-column justify-space-between align-center">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <div class="elevation-10" v-bind="attrs" v-on="on" id="pick-avatar3" style="cursor:pointer">
                    <v-img
                      :lazy-src="logo_3"
                      max-height="250"
                      max-width="250"
                      :src="logo_3"
                    ></v-img>
                  </div>
                </template>
                <span>Cambia</span>
              </v-tooltip>
            </div>
            <avatar-cropper
              :uploadFormData="{name:'logo_3',type:'logo'}"
              :outputOptions="outputOptions3"
              :cropperOptions="cropperOptions3"
              @uploading="handleUploading"
              @uploaded="handleUploaded"
              @completed="handleCompleted"
              @error="handlerError"
              trigger="#pick-avatar3"
              upload-url="https://booking.jslab.it/ajax/settings/upload.php" 
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-dialog v-model="dialog_instruction" max-width="800">
        <v-card>
            <v-card-title class="text-h5 mb-3">
              Istruzioni
              <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction=false">
                  <v-icon color="info">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>               
            </v-card-title>
            <v-divider></v-divider>
            <v-row class="mx-5">
                <v-col md="6" cols="12">
                    <p>
                        Ai fini di semplificare la gestione dell'attività è possibile suddividere l'attività sia in funzione dello spazio che del tempo per adattarla alle proprie necessità:
                    </p>
                    <p>
                      A livello spaziale, distinguiamo tra suddivisioni esplicite (Aree), che il cliente potrà selezionare, e suddivisioni implicite (Sale), che gestirà l'operatore:<br /><br />
                      come suddivisioni esplicite, "interno" ed "esterno" sono solitamente sufficienti, ma qualora vi sia una o più aree particolari è possibile aggiungerle.<br />
                      le suddivisioni implicite invece saranno le sale o porzioni di esse come da voi definite nel riquadro in basso:<br>es: "Sala1", "Sala2", etc. oppure "Sala Interna", "Sala Esterna"
                      una volta create le sale queste andranno "collegate" all'Area di competenza.
                    </p>
                </v-col>
                <v-col md="6" cols="12">
                    <p>
                      Per ogni Area è possibile definire giorno e mese sia di inizo che di fine Operatività: è importante definire questi parametri in quanto l'area sarà prenotabile da parte del cliente solo nel periodo in cui è operativa.
                    </p>                  
                    <p>
                      Il pulsante 'Salva' si attiva qualora rilevi differenze rispetto ai dati memorizzati.
                    </p>
                    <p>
                      Dopo il salvataggio i dati vengono automaticamente ricaricati: qualora notaste delle incongruenze, prima di fare ulteriori modifiche cliccare sul tasto 'Refresh'
                    </p>
                </v-col>
                <v-col cols="12">
                    <p color="error">
                        <strong>Attenzione:</strong> Questi vingoli valgono solo per le prenotazioni dirette da parte dei clienti. L'operatore può accettare qualsiasi prenotazione
                    </p>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>     
  </v-form>
</template>
<script>
import { mapGetters } from "vuex";
import AvatarCropper from "../AvatarCropper";
import _ from 'lodash'
export default {
components: { AvatarCropper },
  data() {
    return {
      page: "Account",
      snackbar: false,     
      message:'',
      logos:null,
      dialog_instruction:false,
      logo_0:'/static/logos/empty_16_16.png',
      logo_1:'/static/logos/empty_400_70.png',
      logo_2:'/static/logos/empty_400_182.png',
      logo_3:'/static/logos/empty_1000_1000.png',
      snackbar_color:'success', 
      outputOptions0:{
        width: 16,
        height: 16,
        minWidth: 16,
        minHeight: 16,
        maxWidth: 16,
        maxHeight: 16,
        fillColor: '#fff',
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'high',
      },
       outputOptions1:{
        width: 400,
        height: 100,
        minWidth: 400,
        minHeight: 100,
        maxWidth: 400,
        maxHeight: 100,
        fillColor: '#fff',
        imageSmoothingEnabled: false,
        imageSmoothingQuality: 'high',
      },
      outputOptions2:{
        width: 400,
        height: 200,
        minWidth: 400,
        minHeight: 200,
        maxWidth: 400,
        maxHeight: 200,
        fillColor: '#fff',
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'high',
      },
      outputOptions3:{
        width: 500,
        height: 500,
        minWidth: 500,
        minHeight: 500,
        maxWidth: 500,
        maxHeight: 500,
        fillColor: '#fff',
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'high',
      },
      cropperOptions0:{aspectRatio: 1, dragMode: 'move',autoCropArea: 0.8,viewMode: 1,movable: true,zoomable: true,center: true,highlight: true,cropBoxMovable: true,cropBoxResizable: false},
      cropperOptions1:{aspectRatio: 4, dragMode: 'move',autoCropArea: 0.8,viewMode: 1,movable: true,zoomable: true,center: true,highlight: true,cropBoxMovable: true,cropBoxResizable: false},
      cropperOptions2:{aspectRatio: 2, dragMode: 'move',autoCropArea: 0.8,viewMode: 1,movable: true,zoomable: true,center: true,highlight: true,cropBoxMovable: true,cropBoxResizable: false}, 
      cropperOptions3:{aspectRatio: 1, dragMode: 'move',autoCropArea: 0.8,viewMode: 1,movable: true,zoomable: true,center: true,highlight: true,cropBoxMovable: true,cropBoxResizable: false} 

    };
  },
  computed: {
      ...mapGetters(["settings"]),
  },
  created(){
    this.getData()
  },
  methods: {
    save: _.debounce(function (event) {
        this.updateDB(event.target.name,event.target.value)
    }, 1000),
    handleUploading({ form, request }) {
      // show a loader
      console.log(174, {form, request})
    },
    handleCompleted({ response,form1 } )
    {
      console.log(184, response)
      console.log(185, form1)
      this[form1.name]=response.payload;
      this.snackbar=true;
      this.snackbar_color='success';
      this.message='Logo saved';
    },
    handleError({ message, type, context}) {
      if (type === 'upload') {
        const { request, response } = context
      console.log(190, form, request, response)
      }
    },
    save2(value, field) {
      //console.log(value, field);
      this.updateDB(field, value)
    },
    async getData(origin)
    {
      try{
          const payload=JSON.stringify({"date": this.date,"action":"AllLogos_get"});
          const res = await this.$http.post('/settings/settings.php', payload );
          console.log(275,res);
          this.loading_refresh=false;
          switch (res.data.errorid)
          {
          case '0':
              sessionStorage.setItem('jwt', res.data.jwt);
              this.logos=res.data.payloads.allLogos;
              this.logos.forEach(l => {
                                        console.log(266,l,l.name,l.URL)
                                        console.log(267,this[l.name])
                                        this[l.name]='/static/pictures/'+l.URL
                                        console.log(269,this[l.name])
                                      }
                                );
              console.log(315,this.logos)
          break;
          case '0006':
              this.$router.push('/auth/login').catch(() => {});
          break;
          }
          this.loading= false;
      } catch(e)
      {
          this.loading= false;
          //console.log(res.data);
      } 
    },    
    async updateDB(fieldname,fieldvalue){
      try{
          const res = await this.$http.post('/account/account_write.php', {"table":"users","fieldname":fieldname,"fieldvalue":fieldvalue});
          console.log(res);
          if (res.data.errorid=='0')
          {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success'
          }
          else
          {
            this.snackbar_color='error'
          }
          this.message=res.data.message;
          this.snackbar=true;
          //this.$store.dispatch("setUser", res.data.user); 
      } catch(e)
      {
        console.log(e)
      }
    }, 
  },
  beforeDestroy() {
    this.form = null;
    delete this.form;
  },
};
</script>